import { startNodeId, startNodeParentId } from "@/constants/reservedNodeIds";

export default () => ({
  id: startNodeId,
  parentId: startNodeParentId,
  nodeComponent: "FlowyBlockNodeStart"
});
